export const FLTOPS_BACKEND = 'https://fltops.boutiqueair.com';
export const MXOPS_BACKEND = 'https://mxops.totaltime.com/api';
export const ROOT_PATH = '/public/';
